import { render, staticRenderFns } from "./choicePatient.html?vue&type=template&id=55029a15&scoped=true&external"
import script from "./choicePatient.js?vue&type=script&lang=js&external"
export * from "./choicePatient.js?vue&type=script&lang=js&external"
import style0 from "./choicePatient.scss?vue&type=style&index=0&id=55029a15&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55029a15",
  null
  
)

export default component.exports